import { render, staticRenderFns } from "./SomethingWentWrong.vue?vue&type=template&id=57a8f1d9&scoped=true"
import script from "./SomethingWentWrong.vue?vue&type=script&lang=js"
export * from "./SomethingWentWrong.vue?vue&type=script&lang=js"
import style0 from "./SomethingWentWrong.vue?vue&type=style&index=0&id=57a8f1d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8f1d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a8f1d9')) {
      api.createRecord('57a8f1d9', component.options)
    } else {
      api.reload('57a8f1d9', component.options)
    }
    module.hot.accept("./SomethingWentWrong.vue?vue&type=template&id=57a8f1d9&scoped=true", function () {
      api.rerender('57a8f1d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SomethingWentWrong.vue"
export default component.exports